import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'
import { RichsnipetService } from 'dmmp-services'

@Component({
  selector: 'dmmp-benefits-video',
  templateUrl: './benefits-video.component.html',
})
export class BenefitsVideoComponent implements OnInit {
  @Input() module
  @Input() identifier
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  schema: object

  constructor(private richsnipetService: RichsnipetService) {}

  ngOnInit() {
    if (
      this.module?.content[0]?.images?.length > 0 ||
      (this.module?.content[0]?.video?.length > 0 &&
        this.module?.content[0]?.video[0]?.video?.length > 0)
    ) {
      this.schema = this.richsnipetService.setupJsonBeneficVideo(
        this.module?.content[0]?.video[0]
      )
    }
  }
}
